import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/iceberg.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6b3da98c")

_pushScopeId("data-v-6b3da98c")
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  width: "35",
  height: "35",
  alt: "",
  class: "d-inline-block align-text-top"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Iceberg ")
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_7 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Get started")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("li", { class: "nav-item dropdown" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "nav-link dropdown-toggle",
    href: "#",
    id: "navbarDropdown",
    role: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
  }, " UI Components "),
  /*#__PURE__*/_createVNode("ul", {
    class: "dropdown-menu",
    "aria-labelledby": "navbarDropdown"
  }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("a", {
        class: "dropdown-item",
        href: "https://main--60b9db85dac2f2003b0bc01b.chromatic.com"
      }, "Angular components")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("a", {
        class: "dropdown-item",
        href: "https://master--60a77b8cca12bc0039e80030.chromatic.com"
      }, "React components")
    ])
  ])
], -1)
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Integrations")
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Contribute")
const _hoisted_17 = { class: "navbar-nav mb-2 mb-lg-0" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_20 = { class: "nav-item dropdown" }
const _hoisted_21 = /*#__PURE__*/_createVNode("a", {
  class: "nav-link dropdown-toggle dropdown-menu-end",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Support ", -1)
const _hoisted_22 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Get Help")
const _hoisted_24 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    class: "dropdown-item",
    href: "https://tradesolution.visualstudio.com/Iceberg/_workitems/create//Issue",
    target: "_blank"
  }, "Report a bug")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    class: "dropdown-item",
    href: "https://tradesolution.visualstudio.com/Iceberg/_workitems/create//Issue",
    target: "_blank"
  }, "Request new component")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withId(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("ul", _hoisted_7, [
          _createVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "getting-started"
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_10, [
            _createVNode("a", {
              href: _ctx.ZeroHeightLink,
              class: "nav-link external-link"
            }, "Styleguide", 8, ["href"])
          ]),
          _hoisted_11,
          _createVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "integrations"
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_14, [
            _createVNode("a", {
              href: _ctx.ZHResourcesLink,
              class: "nav-link external-link"
            }, "Resources", 8, ["href"])
          ]),
          _createVNode("li", _hoisted_15, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "contribute"
            }, {
              default: _withId(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("ul", _hoisted_17, [
          _createVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              class: "nav-link p-2",
              to: "/about"
            }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_20, [
            _hoisted_21,
            _createVNode("ul", _hoisted_22, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/support"
                }, {
                  default: _withId(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _hoisted_24,
              _hoisted_25
            ])
          ])
        ])
      ])
    ])
  ]))
})